import { StorageKey, useAppStorageState } from "../../util/AppStorage";
import { useEffect, useState } from "react";
import Api from "../../util/Api";
import showWhatsNewPopup from "../../popups/whatsNewPopup";

export const HomepagePopup = () => {
    const [whatsNewObjects, setWhatsNewObjects] = useState([]);
    const [finishedOnboarding] = useAppStorageState(StorageKey.FINISHED_ONBOARDING);
    const [hasBeenShown, setHasBeenShown] = useState(false);

    function getWhatsNew() {
        const config = {
            params: {
                'filter[published][EQ]': 1,
                'page[size]': 5,
                'page[number]': 1
            }
        }

        Api.get("/whatsNew", (response) => {
            if (response.data.length) {
                setWhatsNewObjects(response.data);
            }
        }, null, null, null, config);
    }

    function setWhatsNewIsRead() {
        let updatedWhatsNewArray = [...whatsNewObjects]
        updatedWhatsNewArray[0].isRead = 1
        setWhatsNewObjects(updatedWhatsNewArray)
    }

    useEffect(() => {
        if (finishedOnboarding) {
            getWhatsNew();
        }
    }, [finishedOnboarding]);

    useEffect(() => {
        const isUnread = whatsNewObjects[0]?.isRead === false || whatsNewObjects[0]?.isRead === 0;

        if (isUnread && !hasBeenShown) {
            setHasBeenShown(true);
            showWhatsNewPopup(
                whatsNewObjects[0],
                () => setWhatsNewIsRead()
            );
        }
    // eslint-disable-next-line
    }, [whatsNewObjects, hasBeenShown]);

    return null;
}